import { RootState } from '@/lib/store'
import { BookingStep } from '@/lib/types/operations/booking'

// Current state selectors
export const selectActiveStep = (state: RootState) => state.booking.current.activeStep
export const selectStepState = (step: BookingStep) => (state: RootState) => state.booking.current.stepStates[step]
export const selectBookingContext = (state: RootState) => state.booking.current.context
export const selectIsDrawerOpen = (state: RootState) => state.booking.current.isDrawerOpen
export const selectIsSubmitting = (state: RootState) => state.booking.current.isSubmitting

// Persisted state selectors
export const selectBookingOwnerId = (state: RootState) => state.booking.persisted.ownerId
export const selectShopLocation = (state: RootState) => state.booking.persisted.shopLocationId
export const selectVehicleDetails = (state: RootState) => state.booking.persisted.vehicleDetails
export const selectSelectedServices = (state: RootState) => state.booking.persisted.selectedServiceIds
export const selectSelectedOption = (state: RootState) => state.booking.persisted.selectedOption
export const selectContactInfo = (state: RootState) => state.booking.persisted.contactInfo

// Derived selectors
export const selectIsStepValid = (step: BookingStep) => (state: RootState) =>
  state.booking.current.stepStates[step].isValid

export const selectStepErrors = (step: BookingStep) => (state: RootState) =>
  state.booking.current.stepStates[step].errors

export const selectCanProceedToStep = (step: BookingStep) => (state: RootState) => {
  const stepState = state.booking.current.stepStates[step]
  return stepState.isValid
}

export const selectBookingProgress = (state: RootState) => {
  const steps = Object.keys(state.booking.current.stepStates) as BookingStep[]
  const completedSteps = steps.filter(step => state.booking.current.stepStates[step].isValid)
  return {
    total: steps.length,
    completed: completedSteps.length,
    percentage: (completedSteps.length / steps.length) * 100
  }
}

// Vehicle selection selectors
export const selectShowVehicleSelect = (state: RootState) => state.booking.current.showVehicleSelect
export const selectUserVehicles = (state: RootState) => state.booking.current.userVehicles
export const selectIsLoadingVehicles = (state: RootState) => state.booking.current.isLoadingVehicles
export const selectSelectedVehicleId = (state: RootState) => state.booking.persisted.selectedVehicleId

// Validation selectors
export const isValidShopLocationId = (id: string | null | undefined): boolean => {
  return typeof id === 'string' && id.trim().length > 0
}
